module.exports = __webpack_public_path__ + "media/components/dashboard/icons/therapist-illustration-afea94440552b14962eace0455b9457a.svg";